import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PrimeNgModule } from "@primeng";
import { FilterModule } from "@features/filter";
import { WidgetControlSetComponent } from "./components/widget-control-set.component";
import { WidgetControlSetDataService } from "@main/reporting.v3/widget.control-set/api/widget-control-set-data.service";
import { WidgetControlSetViewService } from "@main/reporting.v3/widget.control-set/api/widget-control-set-view.service";
import {
    WidgetControlSetPdfExportingService
} from "@main/reporting.v3/widget.control-set/api/widget-control-set-pdf-exporting.service";
import {
    WidgetControlSetAuxiliaryService
} from "@main/reporting.v3/widget.control-set/api/widget-control-set-auxiliary.service";
import { WidgetControlSetBuilderComponent } from "./components/widget-control-set-builder.component";
import { WidgetControlSetBuilderService } from "./api/widget-control-set-builder.service";
import { ReportingCoreModule } from "../reporting-core.module";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { QueryTableSelectorModule } from "@main/reporting.v3/query-table-selector/query-table-selector.module";
import { BbTooltipModule } from "@features/bb-tooltip";


@NgModule({
    declarations: [
        WidgetControlSetComponent,
        WidgetControlSetBuilderComponent
    ],
    exports: [
        WidgetControlSetComponent,
        WidgetControlSetBuilderComponent
    ],
    imports: [
        CommonModule,
        FilterModule,
        PrimeNgModule,
        BbTooltipModule,
        BbwtSharedModule,

        ReportingCoreModule,
        QueryTableSelectorModule
    ],
    providers: [
        WidgetControlSetPdfExportingService,
        WidgetControlSetAuxiliaryService,
        WidgetControlSetBuilderService,
        WidgetControlSetDataService,
        WidgetControlSetViewService
    ]
})
export class WidgetControlSetModule {
}